import {
  ComposedChart,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts'

export const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="rounded-md border border-th-fgd-3 bg-th-bkg-1 px-4 py-4">
        <p>{label}</p>
        <p className="label">{`${payload[0].name} : ${parseFloat(payload[0].value)}`}</p>
        {payload[1] && (
          <p className="label">{`${payload[1].name} : ${parseFloat(payload[1].value)}`}</p>
        )}
      </div>
    )
  }

  return null
}

const LineChart = ({
  xAxisKey,
  data,
  lineKey,
}: {
  xAxisKey: string
  lineKey?: string
  data: Record<string, any>[]
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data}>
        <XAxis tickLine={false} dataKey={xAxisKey} tickCount={5} />
        <YAxis
          axisLine={false}
          orientation="left"
          yAxisId="left"
          tickLine={false}
          tickSize={0.01}
          tickFormatter={(value) => value.toFixed(3)}
          domain={['auto', 'auto']}
          allowDecimals={true}
        />
        <Tooltip content={<CustomTooltip />} />
        <Line
          yAxisId="left"
          type="natural"
          dataKey={lineKey}
          stroke="#6ee7b7"
          dot={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default LineChart
